import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Spinner: React.FC = () => <FontAwesomeIcon icon={['fas', 'spinner']} spin />;
